<template>
    <div>
      <div class="row justify-content-between align-items-center">
        <div class="col-md-2 customHeading">
          <h3>{{moduleName}}</h3>
        </div>

      <div class = "col-md-3 green-text">
        <b>Remaining Stock in Sacks & KGs: &nbsp;&nbsp;{{mainStock != null ? mainStock.totalNoOfSacks:0}}&nbsp; & &nbsp;{{mainStock != null ? mainStock.totalWeightInKgs:0}}</b>
      </div>
      <div class="col-md-3">
       <b-form-group  label="Start Date" label-for="datepicker-1" autocomplete="off">
          <b-form-datepicker id="datepicker-1" v-model= "StartDate" placeholder="Choose a date" local="en" @input="getWheatIssues()" required></b-form-datepicker>
        </b-form-group>

      </div>
        <div class="col-md-3">
        <b-form-group  label="End Date" label-for="datepicker-2" autocomplete="off">
            <b-form-datepicker id="datepicker-2" v-model= "EndDate" placeholder="Choose a date" local="en" @input="getWheatIssues()" required></b-form-datepicker>
          </b-form-group>
        </div>

        <div class="col-md-1 Add-button" style="text-align:center">
          <a href="javascript:void(0)">
            <div class="AddButton">
              <div class="icon">
                <i class="fas fa-arrow-alt-circle-right fa-1x" style="color: rgb(255, 50, 55);">
                </i>
              </div>
              <div data-text="Add" class="name add-btn" v-b-modal.AddWheatIssueModal>Add </div>
            </div>
          </a>
        </div> 


        <!--
        <div class="col-md-6"><div class="icons_group"><div class="row w3-center"><div class="col-md-2"><a href="#filterSection" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="filterSection"><div class="icon"><i class="fas fa-align-center fa-1x" style="color: rgb(243, 0, 104);"></i></div> <div data-text="Filter" class="name">Filter</div></a></div> <div class="col-md-3"><a href="#"><div class="icon"><i class="fas fa-check-circle fa-1x" style="color: rgb(149, 171, 184);"></i></div> <div data-text="Anti-Spam" class="name">Anti-Spam</div></a></div> <div class="col-md-3"><a href="#"><div class="icon"><i class="fas fa-stream fa-1x" style="color: rgb(255, 143, 38);"></i></div> <div data-target="Autoresponder" class="name">
                                  Auto-responder
        </div></a></div> <div class="col-md-2"><a href="#"><div class="icon"><i class="fas fa-arrow-alt-circle-right fa-1x" style="color: rgb(255, 50, 55);"></i></div> <div data-text="Forward" class="name">Forward</div></a></div> <div class="col-md-2"><a href="#"><div class="icon"><i class="fas fa-trash fa-1x" style="color: rgb(195, 0, 0);"></i></div> <div data-text="delete" class="name">Delete</div></a></div></div></div></div>
       
       --> 
       </div>
       <div class="row">
         <div class="col">
          <hr color="#CACACA" style="border-top: 2px solid rgb(202, 202, 202); margin-top: 5px;">
         </div>
        </div>
      <div>
        <div class="row">
          <div class="col">
          <table class="table table-striped table-borderless cutom-table table-striped table-sm" 
            style="font-size: 85%;">
              <thead>
                <tr>
              
                  <th role="columnheader">Issue Date</th>
                  <th role = "columnheader"> No Of Sacks Issued </th>
                  <th role = "columnheader"> Weight(KGs)</th>
                  <th role = "columnheader"> Weight(TONs)</th>
                  <th role="columnheader" >Actions</th>
                </tr>
              </thead>
              <tbody>
                <!--IF STUDENTS ARRAY HAS NO VALUE THEN SHOW WITHOUT SHOWING DATA-->
                <tr v-if= "wheatIssues==null" >
                  <td colspan="5" class = "center-td">No Data</td>
                </tr>
                
              <tr v-else v-for="issue in wheatIssues" :key=issue.id>
                <td  role="cell">
                
                  {{issue.issuedDateTime| moment("MMMM Do YYYY")}}
                
                </td>
            
              <td>
                {{issue.noOfSacks}}
              </td>
                <td>
                {{issue.issuedWeight}}
              </td>
              <td>
                {{issue.issuedWeight/1000}}
              </td>

                <td>
                
                  <span @click= "passRecordToEdit(issue)">
                    <i role="button" style="color:green" class="far fa-edit"></i>&nbsp;|&nbsp;
                  </span>
                  <span @click= "passRecordToDelete(issue.id)">
                    <i role="button" style="color:green" class="far fa-trash-alt"></i>
                  </span>
                
                </td>
              </tr>
              <tr>
                <td colspan ="1"></td>
                <td><b>Total Sacks: {{totalSacks != null ? totalSacks:0}}</b></td>
                <td><b>Total: {{totalKgs != null ? totalKgs:0}}</b></td>
                <td><b>Total: {{totalKgs != null ? totalKgs/1000:0}}</b></td>
                <td></td>
            </tr>
            </tbody>
          </table>
      </div>
      </div>

      

    <!--PAGINATION START-->
    <div class="row justify-content-between align-items-center">
      <div class="col-md-2">
        <div class="showPages">
          <select class="form-control" id="selClass" v-model="perPage" 
          @change="getWheatIssues()">
            <option v-for="option in options" :key="option.value" :value="option.value">
            {{option.text}}
            </option>
          </select>
        </div>
      </div>

      <div class="col-md-8 d-flex justify-content-center">
        <div class="overflow-auto">
            <b-pagination
              v-model= "page"
              :total-rows= rows
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              @change="getPage"
            ></b-pagination>
          </div>
      </div>

       <div class="col-md-2">
        <input class="form-control search-box page-no-search" type="text" v-bind:placeholder="page" aria-label="search" v-model.number="pageNumOnSearch" style="height:38px">
      
        <button class="search-button btn btn-primary search page-no-search-btn" @click="search()">
              GO
        </button>

       </div>
    </div>
    <!--/PAGINATION END-->	
    <!--SPINNER-->	
    <Spinner v-if="isLoading" message="Loading..." size="medium" 
      line-fg-color="rgb(222 224 219" 
      line-bg-color="rgb(68 66 62)">
    </Spinner>
    <!--/SPINNER-->	
      </div>
      <AddWheatIssueModal/>
    <DeleteModal :msgForModal= "msgForModal" :apiEndPoint = "apiEndPoint" :heading = "deleteModalHeading"  :entityId = "recordToDelete"/>
    <EditWheatIssueModal v-if = "recordToEdit != null" :wheatIssueToEdit = "recordToEdit" />
   </div>
</template>

<script>
import axios from 'axios';
// import config from '../config.js';
import Spinner from 'vue-simple-spinner'
import AddWheatIssueModal from './modals/AddWheatIssueModal'
import DeleteModal from '../../modals/DeleteModal'
import EditWheatIssueModal from './modals/EditWheatIssueModal'

export default {
    name: 'Users',
    data(){
        return{
          moduleName:'Wheat Issues',
          Id:null,
          isLoading:false,
          recordToEdit :  null,
          recordToDelete:null,
          msgForModal:null,
          apiEndPoint:null,
          deleteModalHeading:null,
          statusOptions:
          [
            { value: 0, text: 'All' },
            { value: 1, text: 'Active' },
            { value: 2, text: 'InActive' }
          ],
         
          mainStock:null,
          totalKgs:null,
          totalSacks:null,
          StartDate:new Date(),
          EndDate:new Date(),
          wheatIssues:null,
          selectedStatus:1,
          pageNumOnSearch:'',
          filteredText:'',
          rows:0,
           page: 1,
          options: [
            { text: 'Show 2',  value: 2 },
            { text: 'Show 10',  value: 10 },
            { text: 'Show 25',  value: 25 },
            { text: 'Show 50',  value: 50 },
            { text: 'Show 100', value: 100 }
          ],
          perPage:25
        
		}
  },
 
methods:
{
    getPage(page)
  {
    this.page = page;
    this.getWheatIssues();
  },


  
  passRecordToDelete(id)
  {
    this.recordToDelete = id;
    this.msgForModal = "Confirm to delete !";
    this.apiEndPoint = "wheatissue/Delete/";
    this.deleteModalHeading = "Delete"
    this.$bvModal.show('DeleteModal')

  },
  passRecordToEdit(rec)
  {
    this.recordToEdit = rec;
   setTimeout(
      () => {
   this.$bvModal.show('EditWheatIssueModal')
  },150)
    
    
    // console.log(this.recordToEdit)
  },
    getWheatIssues(){
      this.isLoading = true;
      axios.post('/wheatIssue/getall',{"IssuedFromSilo":false,"UserId":this.$auth.user().id,"CompanyId":this.$auth.user().companyId,
      "PageSize":this.perPage,"Page":this.page,"FromDate":this.StartDate,"ToDate":this.EndDate,})
    .then(res=>{
      this.isLoading = false;
      if(res.data.status ==1)
      {
        // console.log(res.data)
        let response = res.data.data;
        this.wheatIssues=response.records;
        this.mainStock = response.mainStock;
        this.totalSacks =response.totalSacks;
        this.totalKgs = response.totalKgs;
       
        this.rows = res.data.totalRecords;
      }
      else if (res.data.status == 0)
      {
        this.wheatIssues = null;
        this.mainStock = res.data.data.mainStock;
      }
       else if(res.data.status == -1)
      {
          this.$bvModal.msgBoxOk(res.data.msg, {
          title: 'Error',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          headerClass: 'p-10 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
          });
        
      }
    });
    },
		
   

  search(){
   
    this.page=this.pageNumOnSearch;
    this.getWheatIssues();
  }
  },
	created(){
    var date = new Date();
    this.StartDate = new Date(date.getFullYear(), date.getMonth(), 1,this.StartDate.getHours())
    // console.log(this.StartDate)
  // this.StartDate.setFullYear(date.getFullYear(), date.getMonth(), 1)
    this.EndDate = new Date (date.getFullYear(), date.getMonth() + 1, 0,this.EndDate.getHours());
      // console.log(this.EndDate)
    // this.EndDate.setFullYear(date.getFullYear(), date.getMonth() + 1, 0);
    this.getWheatIssues();
    // this.getStudents();
    //localStorage.setItem("mytime", Date.now());
  },
  components:{
    Spinner,
    AddWheatIssueModal,
    DeleteModal,
    EditWheatIssueModal
   
  },
  
}
</script>

<style scoped>
button.page-link {
	display: inline-block;
}
button.page-link {
    font-size: 20px;
    color: #29b3ed;
    font-weight: 500;
}
.offset{
  width: 500px !important;
  margin: 20px auto;  
}
select#class-dropdown{
    width: 80%;
    margin-left: 16%
}
.mleft-right-15{
  margin-left: 15px !important;
  margin-right: 15px !important;
}

.row{
  margin-left:0px;
  margin-right:0px;
}

.col{
  padding-left:0px;
  padding-right:0px;
}

</style>